import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mapProps } from 'recompose';

import CheckoutCart from './CheckoutCart';
import withModal from '../../../../components/global/modal/withModal';
import DismissButton from '../../../../components/global/DismissButton';

const propTypes = {
  className: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const CheckoutCartModalComponent = ({
  className,
  onSuccess,
  onClose,
  ...props
}) => {
  const classes = classNames({
    'modal-contained-wrap': true,
    'checkout-cart-modal': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="purchasing-options-list-header modal-contained-header">
        <span className="modal-contained-title">Your Cart</span>
        <DismissButton className="ml-auto" onClick={onClose} />
      </div>

      <div className="modal-contained-content">
        <CheckoutCart onSuccess={onSuccess} onClose={onClose} {...props} />
      </div>
    </div>
  );
};

CheckoutCartModalComponent.propTypes = propTypes;

export const CHECKOUT_CART_MODAL = 'CHECKOUT_CART_MODAL';

export { CheckoutCartModalComponent };

const CheckoutCartModal = withModal(
  mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
    onClose: onRequestClose,
    ...actionProps,
    ...props,
  }))(CheckoutCartModalComponent),
  {
    name: CHECKOUT_CART_MODAL,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
    className: 'modal-contained checkout-cart-modal-wrapper',
  },
);

export default CheckoutCartModal;
